module.exports = __webpack_public_path__ + "img/mhdz.2a6992a8.png";